import React from "react";
import styles from "./index.module.scss";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Tabs } from '@arco-design/web-react';
import LazyMedia from "@/components/LazyMedia";
const downloadImg = require('../../assets/downloadImg.png')
const TabPane = Tabs.TabPane;
interface ISoftware{
  picoOsList: Record<string, any>[]; // OS下载列表
  words: Record<string, string>;
}
const Download:React.FC<ISoftware> = ({picoOsList,words})=> {

  const location = useLocation();

  // 监听hash变化，滚动到锚点
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [location]);

    return (
      <>
        <div className={styles.download} id="picoos5">
          <div className={styles.downloadTittle}>
            <p className={styles.textTittle}>{words.software_os_title}</p>
            <p className={styles.textContent}>{words.software_os_content}</p>
          </div>
          <LazyMedia type="image" src={downloadImg} className={styles.downloadImg}/>
          {/* <img src={downloadImg} className={styles.downloadImg}/> */}
          <div className={styles.downloadDetail}>
            <p className={styles.downloadDetailTittle}>{words.software_os_dialogTitle}</p>
            <Tabs  type='rounded'>
            {picoOsList.map((data:any,index:number) => (
                <TabPane key={index} title={data.title} >
                  <div className={styles.downloadDetailText}>
                    {data.updateInfo}
                  </div>
                  <a className={styles.downloadBtn} href={data.url} download={data.title}>{words.software_download}</a>
              </TabPane>
            ))}
            </Tabs>
          </div>
        </div>
      </>
    );
  };
  export default Download;
